import { createAction } from '@reduxjs/toolkit';

import { MODAL_TYPES } from 'common/constants/common';

import { CurrentModalParamsType } from './types';

export const hideModalAction = createAction('hide modal');

export const showModalAction = createAction<{
  modalName: MODAL_TYPES;
  params?: CurrentModalParamsType;
  containerId?: string;
}>('show modal');

export const updateModalParamsAction = createAction<{
  params?: Record<string, any>;
  rewrite?: boolean;
}>('update modal params');
